import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="pt-0 pb-0 px-4 bg-white" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#ECFDF5] p-8 md:p-12 rounded-3xl shadow-xl border-4 border-green-500 relative overflow-hidden" data-id="element-95">
          {/* Background decorative shield */}
          <ShieldCheck className="absolute -right-10 -bottom-10 w-64 h-64 text-green-500 opacity-5" data-id="element-96" />

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-97">
            <div className="bg-green-500 p-4 rounded-full mb-6 shadow-lg" data-id="element-98">
              <ShieldCheck className="w-12 h-12 text-white" data-id="element-99" />
            </div>

            <h2 className="text-3xl md:text-4xl font-black text-green-800 mb-6 uppercase tracking-tight" data-id="element-100">
              ✅ Garantía sin riesgo (7 días)
            </h2>

            <p className="text-xl text-green-900 font-medium mb-8 leading-relaxed" data-id="element-101">
              Probalo durante 7 días. Si sentís que no es para vos, pedís el
              reembolso y listo. Cero drama. Cero pelea.
            </p>

            <div className="bg-white p-4 rounded-xl border-2 border-green-300 w-full shadow-sm" data-id="element-102">
              <p className="text-lg md:text-xl font-black text-gray-800" data-id="element-103">
                Garantía 100% respaldada oficialmente por{' '}
                <span className="text-[#009EE3]" data-id="element-104">Mercado Pago</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}